<template>
  <div class="card empty-state">
    <div class="card-content is-flex content-center is-flex-column">
      <img :src="stateicon" :width="size" :height="size"/>
      <h6 class="ptitle heading">{{title}}</h6>
      <p class="desc has-text-centered">
        <slot name="content"></slot>
      </p>
    </div>
  </div>
</template>

<script>
import EmptystateCompany from '@/assets/empty-state-company@2x.png'
import EmptystateEyes from '@/assets/empty-state-eyes@2x.png'
import EmptystateIcon from '@/assets/empty-state-icon@2x.png'
import EmptystateMessage from '@/assets/empty-state-messages@2x.png'

export default {
  data () {
    return {
      icons: {
        'empty-state-message': EmptystateMessage,
        'empty-state-icon': EmptystateIcon,
        'empty-state-company': EmptystateCompany,
        'empty-state-eyes': EmptystateEyes
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: 'empty-state-icon'
    },
    size: {
      type: Number,
      required: false,
      default: 40
    }
  },
  computed: {
    stateicon () {
      if (this.icons[this.icon] !== undefined) {
        return this.icons[this.icon]
      }
      return this.icons['empty_state_icon']
    }
  }
}
</script>

<style lang="scss" scoped>
  p {
    line-height: 1.5rem !important;
  }

  .card-content {
    padding: 16px;

    .ptitle {
      margin-top: 16px;
      margin-bottom: 8px;
      font-size: 12px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 2px;
      text-align: center;
      color: #111111;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/general/empty-state.vue